import { render, staticRenderFns } from "./UserActionsPage.vue?vue&type=template&id=35d848de&"
import script from "./UserActionsPage.vue?vue&type=script&lang=js&"
export * from "./UserActionsPage.vue?vue&type=script&lang=js&"
import style0 from "./UserActionsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports